import {TeamPlanLeadFormEvent} from './team-plan-lead-form-event';

/**
 * Amplitude event fired once when the Team Plan sign-up form is presented to the user.
 */
export class TeamPlanLeadFormPresentedEvent extends TeamPlanLeadFormEvent {
    constructor(formId: string) {
        super('tp_lead_form_presented', formId);
    }
}
